import { AxiosInstance } from 'axios';
import { ScopeTree } from '@/services/Scopes/Models/ScopeTree';
import { ScopeTreeBranch } from '@/services/Scopes/Models/ScopeTreeBranch';
import { ScopeTreeLeaf } from '@/services/Scopes/Models/ScopeTreeLeaf';
import ScopesRepositoryInterface, { ApiScopeResource } from '@/services/Scopes/Interfaces';

export default class ScopesRepository implements ScopesRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllScopes(): Promise<ApiScopeResource[]> {
    const res = await this.axios.get('/auth/scopes');
    return res.data;
  }

  public async getRoleScopes(role: number): Promise<ApiScopeResource[]> {
    const res = await this.axios.get('/auth/roles/' + role + '/scopes');
    return res.data;
  }

  public generateScopeTrees(scopes: ApiScopeResource[]): ScopeTree[] {
    const scopeTreeMap: { [key: string]: ScopeTree } = {};
    scopes.forEach((scope: ApiScopeResource) => {
      const [service, func] = scope.scope.split(':');
      if (scopeTreeMap[service] === undefined) {
        scopeTreeMap[service] = new ScopeTree(service);
      }

      if (func) {
        if (!scopeTreeMap[service].hasChild(func)) {
          scopeTreeMap[service].addChild(new ScopeTreeBranch(func));
        }
        scopeTreeMap[service].getChild(func).addChild(new ScopeTreeLeaf(scope.id, scope.scope));
      }
    });

    return Object.values(scopeTreeMap);
  }

  public async syncScopes(): Promise<void> {
    await this.axios.post('/auth/scopes/sync');
  }
}



